import React, { Component, Fragment } from "react";
import { Card, Col, Row } from "reactstrap";

class RowDetailsCellDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      className,
      title1,
      body1,
      title2,
      body2,
      title3,
      body3,
      title4,
      body4,
      title5,
      body5,
      title6,
      body6,
    } = this.props;

    return (
      <Fragment>
        <Card
          className={className}
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <Row className="no-gutters">
            <Col sm="12">
              <div
                className="card no-shadow rm-border bg-transparent widget-chart text-left"
                style={{ paddingLeft: "10px" }}
              >
                <Fragment>
                  <Col>
                    <div className="widget-chart-content text-left">
                      <div className="widget-subheading">
                        <b style={{ color: "black" }}>{title1}</b>
                      </div>
                      <div className="widget-subheading">{body1}</div>
                    </div>
                  </Col>
                  <Col>
                    <div className="widget-chart-content text-left">
                      <div className="widget-subheading">
                        <b style={{ color: "black" }}>{title2}</b>
                      </div>
                      <div className="widget-subheading">{body2}</div>
                    </div>
                  </Col>
                  <Col>
                    <div className="widget-chart-content text-left">
                      <div className="widget-subheading">
                        <b style={{ color: "black" }}>{title3}</b>
                      </div>
                      <div className="widget-subheading">{body3}</div>
                    </div>
                  </Col>
                  <Col>
                    <div className="widget-chart-content text-left">
                      <div className="widget-subheading">
                        <b style={{ color: "black" }}>{title4}</b>
                      </div>
                      <div className="widget-subheading">{body4}</div>
                    </div>
                  </Col>
                  <Col>
                    <div className="widget-chart-content text-left">
                      <div className="widget-subheading">
                        <b style={{ color: "black" }}>{title5}</b>
                      </div>
                      <div className="widget-subheading">{body5}</div>
                    </div>
                  </Col>
                  <Col>
                    <div className="widget-chart-content text-left">
                      <div className="widget-subheading">
                        <b style={{ color: "black" }}>{title6}</b>
                      </div>
                      <div className="widget-subheading">{body6}</div>
                    </div>
                  </Col>
                </Fragment>
              </div>
              <div className="divider m-0 d-md-none d-sm-block" />
            </Col>
          </Row>
        </Card>
      </Fragment>
    );
  }
}

export default RowDetailsCellDetails;



// WEBPACK FOOTER //
// ./src/Clients/PicaC&SVz/components/RowDetailsCellDetails.js